export default {
      id: "checkmark-usage",
      viewBox: "0 0 48 48",
      url: __webpack_public_path__ + "icons-sprite.c706496.svg#checkmark-usage",
      toString: function () {
        return this.url;
      }
    }